import { runStep } from "./state-machine/stepRunner";
import { TransactionState } from "./state-machine/transitions";

export function createInitialState(): TransactionState {
  return {
    id: crypto.randomUUID(),
    currentStep: "INIT",
    history: []
  };
}

export function step(state: TransactionState): TransactionState {
  return runStep(state);
}

export function runToEnd(state: TransactionState): TransactionState {
  let current = state;

  while (current.currentStep !== "COMPLETED") {
    const next = runStep(current);
    if (next.currentStep === current.currentStep) break;
    current = next;
  }

  return current;
}